<template>
  <div class="home page-template page-template-templates page-template-template-home page-template-templatestemplate-home-php page page-id-4 theme-consumer english">
    <div class="footer-contact-details-container">
        <div class="main-content-container footer-contact-details-block">
            <div class="footer-logo">
                <a class="header-logo" href="https://www.comreg.ie/">
                    <img src="/static/img/logo-ComReg.svg" class="footer-logo-img" alt="Commission for Communications Regulation" style="margin-top:-4px;margin-bottom:-4px;max-height:100px;">
                </a>
            </div>
            <div class="footer-address">
                <p>Commission for Communications Regulation,<br/>
                    Dockland Central, 1 Guild St, North Dock,<br/>
                    Dublin, D01 E4X0</p>
                <a class="footer-map-link" href="https://comreg.ie/contact/#map-anchor">View on Map</a>
            </div>
            <div class="footer-phone">
                <div class="footer-phone-block">
                    <div class="footer-sector-name">Consumer:</div>
                    <div class="footer-phone-numbers">
                        <p><a href="tel:018049668">018049668</a><br>
                            <a class="footer-email" href="mailto:consumerline@comreg.ie">consumerline@comreg.ie</a>
                        </p>
                    </div>
                </div>
                <div class="footer-phone-block">
                    <div class="footer-sector-name">Industry:</div>
                    <div class="footer-phone-numbers">
                        <p><a href="tel:018049600">018049600</a><br>
                            <a class="footer-email" href="mailto:industry@comreg.ie">industry@comreg.ie</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <footer class="footer">
        <div class="footer-content-container">
            <nav role="navigation">
                <ul id="menu-footer-navigation" class="footer-nav">
                    <li class="menu-about-comreg"><a href="https://comreg.ie/about/"><span class="span-lang">About ComReg</span></a></li>
                    <li class="footer-lang menu-as-gaeilge"><a href="https://www.comreg.ie/an-ghaeilge/"><span class="span-lang" lang="ga">An
                                Ghaeilge</span></a></li>
                    <li class="menu-accessibility"><a href="https://comreg.ie/accessibility/"><span class="span-lang">Accessibility</span></a></li>
                    <li class="menu-useful-links"><a title="Useful Links" href="https://comreg.ie/links/"><span class="span-lang">Useful
                                Links</span></a></li>
                    <li class="menu-privacy"><a href="https://comreg.ie/privacy/"><span class="span-lang">Privacy</span></a></li>
                    <li class="menu-disclaimer"><a href="https://comreg.ie/disclaimer/"><span class="span-lang">Disclaimer</span></a></li>
                    <li class="menu-copyright"><a href="https://comreg.ie/copyright/"><span class="span-lang">Copyright</span></a></li>
                    <li class="menu-contact"><a href="https://comreg.ie/contact/"><span class="span-lang">Contact</span></a></li>
                    <li class="menu-site-map"><a href="https://comreg.ie/site-map/"><span class="span-lang">Site Map</span></a></li>
                </ul>
            </nav>
            <div class="footer-social-links">
                <a href="https://twitter.com/comreg" class="footer-social-link" title="This will open twitter in a new tab"
                    target="_blank">
                    <svg class="svg-icon twitter-icon">
                        <use class="footer-social-icon-inner" xlink:href="#twitter"></use>
                    </svg>
                    <span>Twitter</span>
                </a>
                <a href="https://www.linkedin.com/company/comreg" class="footer-social-link" title="This will open linkedin in a new tab"
                    target="_blank">
                    <svg class="svg-icon linkedin-icon">
                        <use class="footer-social-icon-inner" xlink:href="#linkedin"></use>
                    </svg>
                    <span>LinkedIn</span>
                </a>
            </div>
        </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../../static/css/comreg-base.css';

.footer-contact-details-container {
    font-size: 1.8rem;
    line-height: 2.8rem;
}

.footer-phone-block {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
}

.footer-phone-block p {
    margin: 0;
    margin-bottom: 20px;
}

.footer-address p {
    margin: 0;
    margin-bottom: 20px;
}

</style>
